import React from "react";
import TextField from "@material-ui/core/TextField";

const CalculateRatePerHour = (props) => {
  const { classes, state, hourlyContract, handleChange } = props;
  const role = localStorage.getItem('Role');

  return (
    (role === 'HR' || role === 'Admin') && (
      <>
        {hourlyContract ? (
          <>
            <TextField
              id="salary"
              name="salary"
              label="Salary"
              fullWidth
              required
              type="number"
              defaultValue={0}
              InputProps={{ inputProps: { min: 0 } }}
              className={classes.textField}
              value={state?.salary}
              onChange={handleChange}
              margin="normal"
            />

            <TextField
              id="monthlyAssignedHours"
              name="monthlyAssignedHours"
              label="Monthly Assigned Hours"
              fullWidth
              type="number"
              className={classes.textField}
              value={state?.monthlyAssignedHours || ""}
              onChange={handleChange}
              margin="normal"
              inputProps={{ min: 0 }}
              required
            />

            {/* Display rate per hour as a non-editable field */}
            <TextField
              id="perHourSalary"
              name="perHourSalary"
              label="Per Hour Salary"
              fullWidth
              type="text"
              className={classes.textField}
              value={state?.perHourSalary || ""}
              InputProps={{
                readOnly: true, // Make it non-editable
              }}
              margin="normal"
            />
          </>
        ) : (
          <TextField
            id="salary"
            name="salary"
            label="Salary"
            fullWidth
            required
            type="number"
            defaultValue={0}
            InputProps={{ inputProps: { min: 0 } }}
            className={classes.textField}
            value={state.salary}
            onChange={handleChange}
            margin="normal"
          />
        )}
      </>
    )
  );
};

export default CalculateRatePerHour;
